// Core
import React from "react"
import styled from "styled-components"

// General components
import BaseContainer from "../../../../components/BaseContainer"

// Components
import LogoContainer from "./components/LogoContainer"

// Utils
import size from "../../../../styles/size"

const Tag = styled.footer`
  margin-top: 300px;

  background-color: #555555;
  color: #ffffff;
  padding: 30px 0;

  .all-rights {
    margin: 30px 0;
  }

  @media (min-width: 631px) and (max-width: ${size.tablet}) {
    margin-top: 190px;
  }

  @media (max-width: ${size.tabletS}) {
    margin-top: 150px;
  }
`

export default function Footer(props) {
  return (
    <Tag {...props}>
      <BaseContainer displayBlock>
        <LogoContainer />

        <div className="all-rights">
          <strong>Oceano da Graça</strong> 2020 © Todos os Direitos Reservados
        </div>
      </BaseContainer>
    </Tag>
  )
}
